/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConvictionAllocationType } from './ConvictionAllocationType';
import {
    ConvictionAllocationTypeFromJSON,
    ConvictionAllocationTypeFromJSONTyped,
    ConvictionAllocationTypeToJSON,
} from './ConvictionAllocationType';

/**
 * 
 * @export
 * @interface ConvictionAllocation
 */
export interface ConvictionAllocation {
    /**
     * 
     * @type {ConvictionAllocationType}
     * @memberof ConvictionAllocation
     */
    allocationType: ConvictionAllocationType;
    /**
     * 
     * @type {number}
     * @memberof ConvictionAllocation
     */
    currentExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof ConvictionAllocation
     */
    targetExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof ConvictionAllocation
     */
    activeExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof ConvictionAllocation
     */
    maxBuyConstraint?: number;
    /**
     * 
     * @type {number}
     * @memberof ConvictionAllocation
     */
    maxTargetExposure?: number;
}



/**
 * Check if a given object implements the ConvictionAllocation interface.
 */
export function instanceOfConvictionAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "allocationType" in value;

    return isInstance;
}

export function ConvictionAllocationFromJSON(json: any): ConvictionAllocation {
    return ConvictionAllocationFromJSONTyped(json, false);
}

export function ConvictionAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConvictionAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allocationType': ConvictionAllocationTypeFromJSON(json['allocation_type']),
        'currentExposure': !exists(json, 'current_exposure') ? undefined : json['current_exposure'],
        'targetExposure': !exists(json, 'target_exposure') ? undefined : json['target_exposure'],
        'activeExposure': !exists(json, 'active_exposure') ? undefined : json['active_exposure'],
        'maxBuyConstraint': !exists(json, 'max_buy_constraint') ? undefined : json['max_buy_constraint'],
        'maxTargetExposure': !exists(json, 'max_target_exposure') ? undefined : json['max_target_exposure'],
    };
}

export function ConvictionAllocationToJSON(value?: ConvictionAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allocation_type': ConvictionAllocationTypeToJSON(value.allocationType),
        'current_exposure': value.currentExposure,
        'target_exposure': value.targetExposure,
        'active_exposure': value.activeExposure,
        'max_buy_constraint': value.maxBuyConstraint,
        'max_target_exposure': value.maxTargetExposure,
    };
}

